'use client';
import React, { Fragment, useEffect, useState } from 'react';
import PageWrapper from '@/components/general/PageWrapper';
import { Blog, brand, categoryType, ResponseType, ServiceCategory } from '@/commonTypes';
import HomeHero from './HomeHero';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import { Features } from './Features/Features';
import HomeServices from './HomeServices';
import HomeChat from './HomeChat';
import SampleBlogs from './SampleBlogs';
import { AppPromo } from './AppPromo';
import { useTranslations } from 'next-intl';
import MainIcons from '@/icons/main';
import { avatarBg, avatarBgGlow } from '@/functions/formats';
import BrandCard from '../../brand/BrandsContent/BrandCard';
import styles from './styles.module.css';
import SectionHeadMore from './SampleBlogs/SectionHeadMore';
import Api from '@/api';
import { mapBrand } from '@/functions/mapApiData';
interface HomeContentType {
  category?: ResponseType<ServiceCategory>;
  blogs?: ResponseType<Blog>;
  brands?: ResponseType<brand>;
}
export default function HomeContent({ data }: { data?: HomeContentType }) {
  const t = useTranslations('HomePage.features');
  const [brandList, setBrandList] = useState<brand[]>([]);

  useEffect(() => {
    Api.brandList({ params: { start: 0, limit: 6 } })
      .then((res: any) => setBrandList((res?.data?.response || []).map(mapBrand)))
      .catch((err) => {
        console.error('brandList failed:', err);
        setBrandList([]);
      });
  }, []);
  const feat = {
    kicker: t('tag'),
    title: t('title'),
    sub: t('text'),
    cards: [
      {
        icon: <MainIcons.flashIcon />,
        t: t('list.item1.title'),
        d: t('list.item1.text'),
        bg: avatarBg(0),
        glow: 'rgba(255,110,40,.32)',
      },
      {
        icon: <MainIcons.carIcon />,
        t: t('list.item2.title'),
        d: t('list.item2.text'),
        bg: avatarBg(1),
        glow: 'rgba(45,107,255,.3)',
      },
      {
        icon: <MainIcons.chartIcon />,
        t: t('list.item3.title'),
        d: t('list.item3.text'),
        bg: avatarBg(2),
        glow: 'rgba(122,91,255,.3)',
      },
      {
        icon: <MainIcons.locationIcon />,
        t: t('list.item4.title'),
        d: t('list.item4.text'),
        bg: avatarBg(3),
        glow: 'rgba(60,230,160,.28)',
      },
    ],
  };
  const brands = {
    kicker: 'برندهای خودرو',
    title: 'برندهای منتخب',
    text: 'به‌جای استعلام جداگانهٔ هر پلاک، همهٔ خودروهای خود را در یک داشبورد امن کنترل کنید.',
    all: 'مشاهده همه برند‌ها',
    cards: brandList,
  };
  return (
    <>
      <PageWrapper>
        <ViewportWrapper className={`w-full`}>
          <HomeHero />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`w-full mt-0 section-light p-0`}>
        <ViewportWrapper className={`container py-0`}>
          <Features feat={feat} position="center" />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`w-full mt-0 section-paper p-0`}>
        <ViewportWrapper className={`container py-0`}>
          <HomeServices services={data?.category?.response} />
        </ViewportWrapper>
      </PageWrapper>
      {/* <PageWrapper className={`w-full mt-0`}>
        <ViewportWrapper className={`w-full`}>
          <HomeChat />
        </ViewportWrapper>
      </PageWrapper> */}
      {brands?.cards?.length != 0 && (
        <PageWrapper className="mt-0 section-light  mb-4px">
          <ViewportWrapper className={`container`}>
            <SectionHeadMore item={brands} href={'/brands'} />
            <div className={`grid_6`}>
              {brands?.cards?.map((item, index) => (
                <BrandCard
                  key={index}
                  item={item}
                  index={index}
                  className={`${styles.brandCard} movingCard`}
                  homePage={true}
                />
              ))}
            </div>
          </ViewportWrapper>
        </PageWrapper>
      )}
      <PageWrapper className={`w-full mt-0`} style={{ backgroundColor: 'var(--paper)' }}>
        <ViewportWrapper className={`container py-0`}>
          <SampleBlogs />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`w-full mt-0`} style={{ backgroundColor: 'var(--paper)' }}>
        <ViewportWrapper className={`container`}>
          <AppPromo />
        </ViewportWrapper>
      </PageWrapper>
    </>
  );
}
